export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70a3b34d1eef2558f6f2571e55c2ce70b81cd8338b&name=pushAdClickData!'